import {
  FetchCompanyTabCacheKey,
  FetchCompanyTabsCacheKey
} from './companyTabsTypes';

export class CompanyTabsCache {
  static indexCacheKey() {
    return 'company-tabs' as FetchCompanyTabsCacheKey;
  }

  static showCacheKey() {
    return 'company-tab' as FetchCompanyTabCacheKey;
  }
}
